var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "MailAccountConfig",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: {
                    name: _vm.formName,
                    readonly: _vm.resource.locked,
                    labelAlign: _vm.$config.forms.defaultLabelAlign,
                    id: _vm.formId
                  },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpRow",
                    [
                      _c(
                        "ItpCol",
                        [
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "address",
                                label: _vm.config.address.label,
                                helpTooltip: _vm.config.address.help,
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "address", required: "" },
                                model: {
                                  value: _vm.editor.address,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "address", $$v)
                                  },
                                  expression: "editor.address"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "description",
                                label: _vm.config.description.label,
                                helpTooltip: _vm.config.description.help
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "description" },
                                model: {
                                  value: _vm.editor.description,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "description", $$v)
                                  },
                                  expression: "editor.description"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("HR"),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "use_credentials",
                                label: _vm.config.use_credentials.label,
                                helpTooltip: _vm.config.use_credentials.help
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "use_credentials" },
                                model: {
                                  value: _vm.editor.use_credentials,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "use_credentials", $$v)
                                  },
                                  expression: "editor.use_credentials"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "username",
                                label: _vm.config.username.label,
                                helpTooltip: _vm.config.username.help,
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "username", required: "" },
                                model: {
                                  value: _vm.editor.username,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "username", $$v)
                                  },
                                  expression: "editor.username"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "password",
                                label: _vm.config.password.label,
                                helpTooltip: _vm.config.password.help
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { type: "password", name: "password" },
                                model: {
                                  value: _vm.change_password.password,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.change_password,
                                      "password",
                                      $$v
                                    )
                                  },
                                  expression: "change_password.password"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "confirm_password",
                                label: _vm.config.confirm_password.label,
                                helpTooltip: _vm.config.confirm_password.help
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  type: "password",
                                  name: "confirm_password"
                                },
                                model: {
                                  value: _vm.change_password.confirm_password,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.change_password,
                                      "confirm_password",
                                      $$v
                                    )
                                  },
                                  expression: "change_password.confirm_password"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("HR"),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "tls",
                                label: _vm.config.tls.label,
                                helpTooltip: _vm.config.tls.help
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "tls" },
                                model: {
                                  value: _vm.editor.tls,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "tls", $$v)
                                  },
                                  expression: "editor.tls"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "ssl",
                                label: _vm.config.ssl.label,
                                helpTooltip: _vm.config.ssl.help
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "ssl" },
                                model: {
                                  value: _vm.editor.ssl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "ssl", $$v)
                                  },
                                  expression: "editor.ssl"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "server",
                                label: _vm.config.server.label,
                                helpTooltip: _vm.config.server.help,
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "server", required: "" },
                                model: {
                                  value: _vm.editor.server,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "server", $$v)
                                  },
                                  expression: "editor.server"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "2",
                                name: "port",
                                label: _vm.config.port.label,
                                helpTooltip: _vm.config.port.help,
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  type: "number",
                                  name: "port",
                                  required: ""
                                },
                                model: {
                                  value: _vm.editor.port,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "port", $$v)
                                  },
                                  expression: "editor.port"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "mail_from_name",
                                label: _vm.config.mail_from_name.label,
                                helpTooltip: _vm.config.mail_from_name.help,
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "mail_from_name", required: "" },
                                model: {
                                  value: _vm.editor.mail_from_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "mail_from_name", $$v)
                                  },
                                  expression: "editor.mail_from_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "validate_certs",
                                label: _vm.config.validate_certs.label,
                                helpTooltip: _vm.config.validate_certs.help
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "validate_certs" },
                                model: {
                                  value: _vm.editor.validate_certs,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "validate_certs", $$v)
                                  },
                                  expression: "editor.validate_certs"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "2",
                                name: "timeout",
                                label: _vm.config.timeout.label,
                                helpTooltip: _vm.config.timeout.help,
                                required: "",
                                contentClass: "input-group"
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  type: "number",
                                  name: "timeout",
                                  required: ""
                                },
                                model: {
                                  value: _vm.editor.timeout,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "timeout", $$v)
                                  },
                                  expression: "editor.timeout"
                                }
                              }),
                              _vm._v(" "),
                              _c("DIV", { staticClass: "input-group-append" }, [
                                _c(
                                  "span",
                                  { staticClass: "input-group-text" },
                                  [
                                    _vm._v(
                                      "\n                sec\n              "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.resource.isNew
                ? _c(
                    "ItpForm",
                    {
                      attrs: {
                        name: _vm.sendTestEmailFormName,
                        labelAlign: _vm.$config.forms.defaultLabelAlign
                      },
                      on: {
                        submit: function($event) {
                          return _vm.evh_4186377094414664_submit($event, {})
                        }
                      }
                    },
                    [
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            labelColsMd: "3",
                            contentColsMd: "9",
                            name: "recipient",
                            label: _vm._f("pgettext")(
                              "Send test email",
                              "MailAccountConfig"
                            ),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "DIV",
                            { staticClass: "input-group" },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "recipient", required: "" },
                                model: {
                                  value: _vm.recipient,
                                  callback: function($$v) {
                                    _vm.recipient = $$v
                                  },
                                  expression: "recipient"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "input-group-append" },
                                [
                                  _c("ItpButton", {
                                    attrs: {
                                      type: "submit",
                                      text: _vm._f("pgettext")(
                                        "Send",
                                        "MailAccountConfig|Button"
                                      ),
                                      spinning:
                                        _vm.actions.sendTestEmail.isRunning
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.evh_4699325371235600_clickPreventStop(
                                          $event,
                                          {}
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpAlert",
                            {
                              staticClass: "mt-3",
                              attrs: {
                                type: "success",
                                show: _vm.sendMailTestResult === "success",
                                dismissible: ""
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("pgettext")(
                                        "Email has been successfully sent.",
                                        "MailAccountConfig"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              !_vm.resource.isNew
                ? _c("ItpButton", {
                    staticClass: "mr-auto",
                    attrs: {
                      text: _vm._f("pgettext")("Delete", "Button"),
                      variant: "danger",
                      icon: "fa-times",
                      spinning: _vm.actions.delete.isRunning
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_1548630417156826_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  form: _vm.forms[_vm.formName] && _vm.forms[_vm.formName].id,
                  text: _vm._f("pgettext")("Save", "Button"),
                  type: "submit",
                  variant: "primary",
                  default: "",
                  spinning: _vm.actions.submit && _vm.actions.submit.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Close", "Button"),
                  variant: "default",
                  disabled: _vm.actions.submit && _vm.actions.submit.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_2186679009640457_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }